<div *ngIf="inputForm">
  <form [formGroup]="inputForm">
    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>Messstellenbetreiber</mat-label>
      <mat-select formControlName="meterOperator">
        <mat-option *ngFor="let ele of meterOperatorConst" [value]="ele.value">
          {{ ele.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
